(() => {
  const root = document.querySelector("[data-th-inspirations]");
  if (!root) return;

  const drawer = root.querySelector("[data-th-insp-drawer]");
  const list = root.querySelector("[data-th-insp-list]");
  const scrim = root.querySelector("[data-th-insp-scrim]");
  const closeBtn = root.querySelector("[data-th-insp-close]");
  const addBtn = root.querySelector("[data-th-insp-add-cart]");
  const statusEl = root.querySelector("[data-th-insp-status]");
  if (!drawer || !list || !scrim || !addBtn) return;

  let activeCard = null;
  let items = [];

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  }

  function close() {
    drawer.hidden = true;
    drawer.setAttribute("aria-hidden", "true");
    scrim.hidden = true;
    root.classList.remove("is-open");
    if (activeCard) {
      activeCard.classList.remove("is-active");
      activeCard.querySelectorAll(".th-insp__pin").forEach((p) => p.classList.remove("is-gold"));
    }
    activeCard = null;
    items = [];
    list.innerHTML = "";
    if (statusEl) {
      statusEl.hidden = true;
      statusEl.textContent = "";
    }
    addBtn.disabled = false;
    document.documentElement.style.overflow = "";
  }

  function sideForCard(card) {
    const rect = card.getBoundingClientRect();
    const mid = rect.left + rect.width / 2;
    return mid < window.innerWidth / 2 ? "right" : "left";
  }

  function collectProducts(card, focusPinId) {
    const pins = [...card.querySelectorAll("[data-th-insp-pin]")];
    return pins.map((pin) => ({
      pinId: pin.dataset.pinId,
      variantId: pin.dataset.variantId,
      available: pin.dataset.available !== "false",
      title: pin.dataset.title || "",
      price: pin.dataset.price || "",
      url: pin.dataset.url || "#",
      thumb: pin.dataset.thumb || "",
      removed: false,
      focus: pin.dataset.pinId === focusPinId,
    }));
  }

  function renderList() {
    list.innerHTML = "";
    items.forEach((item, index) => {
      const row = document.createElement("div");
      row.className = "th-insp__row" + (item.removed ? " is-removed" : "");
      row.dataset.index = String(index);
      row.dataset.pinId = item.pinId;

      const img = document.createElement("img");
      img.className = "th-insp__row-thumb";
      img.alt = item.title;
      if (item.thumb) img.src = item.thumb;

      const copy = document.createElement("div");
      copy.className = "th-insp__row-copy";
      const title = document.createElement("a");
      title.className = "th-insp__row-title";
      title.href = item.url;
      title.textContent = item.title;
      const price = document.createElement("span");
      price.className = "th-insp__row-price";
      price.textContent = item.available ? item.price : "Elfogyott";
      copy.append(title, price);

      const remove = document.createElement("button");
      remove.type = "button";
      remove.className = "th-insp__row-remove";
      remove.textContent = item.removed ? "Vissza" : "Törlés";
      remove.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        item.removed = !item.removed;
        renderList();
        syncCartButton();
      });

      row.append(img, copy, remove);
      row.addEventListener("mouseenter", () => highlightPin(item.pinId, true));
      row.addEventListener("mouseleave", () => highlightPin(item.pinId, false));
      list.appendChild(row);
    });
    syncCartButton();
  }

  function highlightPin(pinId, on) {
    if (!activeCard) return;
    activeCard.querySelectorAll("[data-th-insp-pin]").forEach((pin) => {
      if (pin.dataset.pinId === pinId) pin.classList.toggle("is-gold", on);
    });
  }

  function syncCartButton() {
    const count = items.filter((i) => !i.removed && i.available && i.variantId).length;
    addBtn.disabled = count === 0;
    addBtn.textContent = count > 0 ? `Kosárba (${count})` : "Kosárba";
  }

  function open(card, focusPin) {
    if (activeCard && activeCard !== card) close();
    activeCard = card;
    items = collectProducts(card, focusPin?.dataset?.pinId);
    if (!items.length) return;

    root.classList.add("is-open");
    card.classList.add("is-active");
    scrim.hidden = false;
    drawer.hidden = false;
    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.remove("is-left", "is-right");
    drawer.classList.add(sideForCard(card) === "right" ? "is-right" : "is-left");
    document.documentElement.style.overflow = "hidden";
    renderList();

    if (focusPin) {
      highlightPin(focusPin.dataset.pinId, true);
      const row = list.querySelector(`[data-pin-id="${CSS.escape(focusPin.dataset.pinId)}"]`);
      if (row) row.classList.add("is-hover");
    }
  }

  async function addToCart() {
    const payload = items
      .filter((i) => !i.removed && i.available && i.variantId)
      .map((i) => ({ id: Number(i.variantId), quantity: 1 }));
    if (!payload.length) return;

    addBtn.disabled = true;
    if (statusEl) {
      statusEl.hidden = false;
      statusEl.textContent = "Hozzáadás...";
    }

    try {
      const res = await fetch(`${rootPath()}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: payload }),
      });
      if (!res.ok) throw new Error("cart add failed");
      const cart = await (await fetch(`${rootPath()}cart.js`, { credentials: "same-origin" })).json();
      document.dispatchEvent(new CustomEvent("cart:change", { detail: { cart } }));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      if (statusEl) statusEl.textContent = "Hozzáadva a kosárhoz";
      setTimeout(close, 700);
    } catch (err) {
      if (statusEl) statusEl.textContent = "Nem sikerült a kosárba tenni";
      addBtn.disabled = false;
    }
  }

  root.addEventListener("click", (event) => {
    const closeHit = event.target.closest("[data-th-insp-close]");
    if (closeHit) {
      event.preventDefault();
      close();
      return;
    }

    const pin = event.target.closest("[data-th-insp-pin]");
    if (pin) {
      event.preventDefault();
      event.stopPropagation();
      const card = pin.closest("[data-th-insp-card]");
      if (card) open(card, pin);
      return;
    }

    const openHit = event.target.closest("[data-th-insp-open]");
    if (openHit) {
      const card = openHit.closest("[data-th-insp-card]");
      if (card) open(card, card.querySelector("[data-th-insp-pin]"));
    }
  });

  scrim.addEventListener("click", close);
  closeBtn?.addEventListener("click", (event) => {
    event.preventDefault();
    close();
  });
  addBtn.addEventListener("click", (event) => {
    event.preventDefault();
    addToCart();
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !drawer.hidden) close();
  });
})();
